import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-corporate',
  templateUrl: './corporate.component.html',
  styleUrls: ['./corporate.component.scss'],
})
export class CorporateComponent {}
